import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/styles/landing-responsive.css";
import "@/styles/landing-light-mode.css";
import App from "@/App";
import { resetHomeScrollOnReload } from "@/lib/scrollReset";
import { registerServiceWorker } from "@/lib/pwa";

if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

resetHomeScrollOnReload();
registerServiceWorker();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const app = (
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  process.env.NODE_ENV === "production" ? <React.StrictMode>{app}</React.StrictMode> : app,
);
